
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Text, Flex, Box } from '../../shared/components';

class UserInfo extends React.Component {
  render() {
    let rol = '';
    let nombre = '';
    let tiendaId;
    let cdgCliente;
    const { user, tiendas } = this.props;
    if (user) {
      const { user_info: userInfo, cliente_deipe } = user;
      cdgCliente = cliente_deipe;
      if (userInfo) {
        const { perfil, usuario, tienda_id } = userInfo;
        nombre = usuario;
        tiendaId = tienda_id;
        if (perfil) {
          const { descripcion } = perfil;
          rol = descripcion;
        }
      }
    }
    let tienda = '';
    tienda = tiendas.find(el => el.id == tiendaId);
    return (
      <Box>
        <Flex height="64px" justifyContent="center" flexDirection="column" alignItems="flex-end">
          <Text lineHeight="normal">{nombre} ({rol})</Text>
          <Text lineHeight="normal">CCD:{cdgCliente} - {tienda?.nombre} </Text>
        </Flex>
      </Box>
    );
  }
}
const mapStateToProps = ({ auth, core }) => ({
  user: auth.user,
  tiendas: core.tiendas,
});

UserInfo.propTypes = {
  user: PropTypes.shape({
    nombre: PropTypes.string,
    rol: PropTypes.string,
    tienda_id: PropTypes.number,
  }),
};

export default connect(mapStateToProps, null)(UserInfo);
